import { INSPECTIONS_URLS } from 'constants/urls'

export const INSPECTIONS = INSPECTIONS_URLS.INSPECTIONS
export const REVIEW_INSPECTION = INSPECTIONS_URLS.REVIEW_INSPECTION
export const VIEW_INSPECTION = INSPECTIONS_URLS.VIEW_INSPECTION
